
const UPDATE_PROJECT_TYPE_PUR = function (state, payload) {
  state.projectTypeOfPur = payload;
};
const UPDATE_PURCHASE_TYPE = function (state, payload) {
  state.purchaseType = payload;
};
const UPDATE_PURCHASE_PROCESS_LIST = function (state, payload) {
  state.purchaseProcessList = payload;
};
const UPDATE_GOODS_TYPE = function (state, payload) {
  state.goodsType = payload;
};
export const mutations = {
  UPDATE_PROJECT_TYPE_PUR,
  UPDATE_PURCHASE_TYPE,
  UPDATE_PURCHASE_PROCESS_LIST,
  UPDATE_GOODS_TYPE
};
